// Campaign Model
cv.Campaign = Backbone.RESTModel.extend({
  defaults: {},

  saveMap: {
    title: "title",
    subtitle: "subtitle",
    domain_name: "domain_name",
    custom_domain_name: "custom_domain_name",
    contact_email: "contact_email",
    contact_address: "contact_address",
    notification_emails: "notification_emails",

    timezone: "timezone",

    fb_og_image: "fb_og_image",
    fb_og_description: "fb_og_description",
    fb_og_title: "fb_og_title",

    summary_email: "summary_email",
    advocate_email: "advocate_email",
    donation_email: "donation_email",
    notif_registration: "notif_registration",

    metadata_1: "metadata_1",
    metadata_2: "metadata_2",
    metadata_3: "metadata_3",
    metadata_4: "metadata_4",

    enable_compact_tiers: "enable_compact_tiers",
    tiers: "tiers",
    recurring_tiers: "recurring_tiers",

    enable_campaign_end_date: "enable_campaign_end_date",
    end_date: "end_date",

    enable_funds_needed: "enable_funds_needed",
    funds_needed: "funds_needed",
    enable_registration_total: "enable_registration_total",

    enable_metric: "enable_metric",
    metric_value: "metric_value",
    metric_description: "metric_description",

    enable_flex_metric: "enable_flex_metric",
    flex_metric_goal: "flex_metric_goal",
    flex_metric_description: "flex_metric_description",

    'payment_processor' : {
      'account_id' : 'payment_processor.account_id',
      'type' : 'payment_processor.type'
    },
    currency_code: "currency_code",

    enable_recurring: "enable_recurring",
    recurring_default: "recurring_default",
    recurring_mandatory: "recurring_mandatory",

    enable_tipping: "enable_tipping",
    enable_cv_tip: "enable_cv_tip",
    tip_mandatory: "tip_mandatory",
    tip_percent: "tip_percent",

    enable_postal: "enable_postal",

    post_donation_text: "post_donation_text",
    redirect_url: "redirect_url",

    enable_ga: "enable_ga",
    ga_id: "ga_id",

    enable_hs_tracking: "enable_hs_tracking",
    hs_tracking_code: "hs_tracking_code",
    enable_fb_tracking: "enable_fb_tracking",
    fb_tracking_code: "fb_tracking_code",

    donation_receipt_branding: "donation_receipt_branding",
    donation_receipt_cc_emails: "donation_receipt_cc_emails",
    donation_receipt_bcc_emails: "donation_receipt_bcc_emails",
    donation_receipt: "donation_receipt",

    enable_registration_quantity: "enable_registration_quantity",
    enable_registration_promo_code: "enable_registration_promo_code",
    notif_new_registration: "notif_new_registration",
    enable_p2p_registrations: "enable_p2p_registrations",
    registration_receipt: "registration_receipt",
    registration_receipt_cc_emails: "registration_receipt_cc_emails",
    registration_receipt_bcc_emails: "registration_receipt_bcc_emails",
    registration_tiers: "registration_tiers",

    enable_projects: "enable_projects",
    default_fundraiser_appeal: "default_fundraiser_appeal",
    default_fundraiser_photo: "default_fundraiser_photo",
    enable_project_end_date: "enable_project_end_date",
    recommended_amount: "recommended_amount",
    private: "private",
    invite_code: "invite_code",
    enable_teams: "enable_teams",
    default_team_photo: "default_team_photo",
    enable_team_funds_needed: "enable_team_funds_needed",
    default_team_appeal: "default_team_appeal",

    enable_welcome_email: "enable_welcome_email",
    welcome_email: "welcome_email",

    setup: "setup",
    setup_design: "setup_design",
    setup_p2p: "setup_p2p",
    setup_donation: "setup_donation",
    active: "active",
    archived: "archived",
    type: "type",
    fundraising_types: "fundraising_types",
    playbook: "playbook",
    status: "status",
  },

  urlRoot: function () {
    return cv.api_path + "/campaigns";
  },

  initialize: function () {
    console.log("Campaign model loaded.");
  },
});
Cocktail.mixin(cv.Campaign, cv.mixins.SyncModel);

// Campaigns Collection
cv.Campaigns = Backbone.Collection.extend({
  initialize: function (options) {
    console.log("Campaign collection initialized.");
  },

  url: function () {
    return cv.api_path + "/campaigns?" + $.param(this.params);
  },

  model: cv.Campaign,
});
Cocktail.mixin(cv.Campaigns, cv.mixins.PaginateModel);

// Define the datastore
DS.defineResource({
  name: "campaign",
  idAttribute: "id", // 'id' is the default
  collection: cv.Campaigns,
  model: cv.Campaign,
});
